export const translations = {
  en: {
    title: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM",
    warningTitle: "Lightning Advisory for Timor-Leste",
    advisoryNumber: "Advisory number: ",
    issuedBy: "Issued by:",
    issuedAt: "Date & Time: ",
    overview: "Overview:",
    highRiskWarningPart1: "A forecast has been issued for high lightning risk hotspots in several post admins within [highRiskMunicipalities]. Immediate precautions are recommended to prevent lightning incidents.",
    moderateRiskWarning: "Moderate risk of lightning activity is expected in [moderateRiskAreas].",
    highRiskWarningPart2: "There may be temporary localized strong winds during thundershowers. The general public is kindly requested to take adequate precautions to minimize damages caused by lightning activity.",
    impact: "Impact and Risk Information:",
    generalAdvisory: "General Advisory:",
    advisoryIntro:
      "The Disaster Risk Reduction Decision Support System advises the following precautions to ensure safety and mitigate Lightning risks:",
    advisoryTableHeaders: ["Type", "Advisory"],
    advisoryPoints: [
      {
        type: "Shelter",
        points: ["Seek shelter, preferably indoors and never under trees."]
      },
      {
        type: "Avoid Open Areas",
        points: ["Avoid open areas such as paddy fields, plantations, and open water bodies during thunderstorms."]
      },
      {
        type: "Electrical Safety",
        points: ["Avoid using wired telephones and connected electric appliances during thunderstorms."]
      },
      {
        type: "Vehicle Safety",
        points: ["Avoid using open vehicles, such as bicycles, tractors, and boats."]
      },
      {
        type: "Environmental Hazards",
        points: ["Beware of fallen trees and power lines."]
      },
      {
        type: "Emergency Assistance",
        points: ["For emergency assistance, contact the local disaster management authorities."]
      }
    ],
    noteLabel: "Note:",
    noteText:
      "The report is valid for the next 24 hours. Please monitor the website for additional information and alerts issued by the Department of Meteorology.",
    footer:
      "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM (DRRDSS), Email: timor-leste@rimes.int, Phone: +670-74520986",
    page: "Page [i] of [pageCount]",
  },
  tetum: {
    title: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE",
    warningTitle: "Aviso Kona-ba Rai-hukar iha Timor-Leste",
    advisoryNumber: "Númeru Aviso: ",
    issuedBy: "Ema-husik husi: ",
    issuedAt: "Data no Oras: ",
    overview: "Visaun Jeral",
    highRiskWarningPart1: "Hahu previsaun atu mosu fatin boot-risku rai-hukar iha balun postu administrativu sira iha munisípiu boot-risku. Precaução urgente rekomenda atu prevene susar rai-hukar.",
    moderateRiskWarning: "Risku moderadu kona-ba atividade rai-hukar espera iha [moderateRiskAreas].",
    highRiskWarningPart2: "Bele iha ventu forte lokal temporariu durante rai-hukar. Públiku jeral husu atu halo prevensaun adekuadu hodi minimiza estragu sira ne’ebé rai-hukar bele kauza.",
    impact: "Informasaun Kona-ba Efeitu no Risku:",
    generalAdvisory: "Konsellu Jeral:",
    advisoryIntro:
      "Sistema Apoiu Desizaun Redusaun Risku Dezastre konsella medida prevensaun tuir mai atu garante seguransa no mitiga risku rai-hukar:",
    advisoryTableHeaders: ["Tipu", "Konsellu"],
    advisoryPoints: [
      {
        type: "Abrigu",
        points: ["Buka fatin abrigadu, preferensialmente iha laran uma no nunka iha ai-hun okos."]
      },
      {
        type: "Evita Fatin Abertu",
        points: ["Evita fatin abertu hanesan to’os, plantasaun, no tasi ibun sira durante rai-hukar."]
      },
      {
        type: "Seguransa Eletrika",
        points: ["Evita uza telefoni ho kabu no aparelhu eletrisidade ne’ebé konektadu durante rai-hukar."]
      },
      {
        type: "Seguransa Veíkulu",
        points: ["Evita uza veíkulu abertu, hanesan bisikleta, trator, no ro."]
      },
      {
        type: "Perigu Ambiental",
        points: ["Kuidadu ho ai-hun ne’ebé monu no liña eletrika."]
      },
      {
        type: "Asisténsia Emerjénsia",
        points: ["Ba asisténsia emerjénsia, kontaktu autoridade jestaun dezastre lokál."]
      }
    ],
    noteLabel: "Nota:",
    noteText:
      "Relatóriu ne’e válidu ba oras 24 oin. Favor monitoriza website ba informasaun adisional no alerta sira ne’ebé Departamentu Meteorolojia ema-husik.",
    footer:
      "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE (DRRDSS), Email: timor-leste@rimes.int, Telefone: +670-74520986",
    page: "Pajina [i] husi [pageCount]",
  },
};

export const riskTranslations = {
  en: {
    'High': "High",
    'Medium': "Medium",
    'Low': "Low",
    'NoRisk': "No Risk",
    "N/A": "N/A",
  },
  tetum: {
    'High': "Altus",
    'Medium': "Moderadu",
    'Low': "Kraik",
    'NoRisk': "La iha Risku",
    "N/A": "N/A",
  },
};

export const characteristicColors = {
  'High': [230, 45, 58],       // Red
  'Medium': [243, 155, 58],    // Orange
  'Low': [243, 235, 18],       // Yellow
  'NoRisk': [148, 203, 85],    // Green
  "N/A": [222, 222, 223],      // Gray
};

export function drawLegend(pdf, currentY, sideMargin, riskT, characteristicColors) {
  const legendWidth = 30;
  const legendHeight = 5;
  const legendGap = 5;
  const textOffset = 5;

  const risks = ['High', 'Medium', 'Low', 'NoRisk'];
  risks.forEach((risk, index) => {
    pdf.setFillColor(...characteristicColors[risk]);
    pdf.rect(sideMargin, currentY + index * (legendHeight + legendGap), legendWidth, legendHeight, 'F');
    pdf.setTextColor(0, 0, 0);
    pdf.text(riskT[risk], sideMargin + legendWidth + textOffset, currentY + index * (legendHeight + legendGap) + legendHeight / 2 + 1);
  });

  return currentY + risks.length * (legendHeight + legendGap) + 5;
}